// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import setCanSendReturnRequest from "@insite/client-framework/Store/Pages/RequestRma/Handlers/SetCanSendReturnRequest";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { OrderLineHeaderStyles } from "@store/Library/Components/OrderLineHeader";
import RequestRmaButtons from "@store/Overrides/Widgets/RequestRma/RequestRmaButtons";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapDispatchToProps = {
    setCanSendReturnRequest,
};

type Props = WidgetProps & ResolveThunks<typeof mapDispatchToProps>;

export interface RequestRmaFormStyles {
    container?: GridContainerProps;
    formGridItem?: GridItemProps;
    listLineHeaderStyles?: OrderLineHeaderStyles;
    inputContainer?: GridContainerProps;
    emailGridItem?: GridItemProps;
    phoneNumberGridItem?: GridItemProps;
    notesGridItem?: GridItemProps;
}

export const requestRmaFormStyles: RequestRmaFormStyles = {
    container: {
        css: css`
            form {
                width: 100%;
            }
        `,
    },
    formGridItem: { width: 12 },

    inputContainer: {
        css: css`
            margin-top: ${pxToRem(10)};
        `,
    },
    emailGridItem: { width: [12, 12, 6, 3, 3] },
    phoneNumberGridItem: { width: [12, 12, 6, 3, 3] },
    notesGridItem: { width: [12, 12, 6, 8, 8] },
};

const styles = requestRmaFormStyles;

const phoneRegex = /^([\(\)/\-\.\+\s]*\d\s?(ext)?[\(\)/\-\.\+\s]*){10,}$/;

type Validator = () => boolean;
type ContextType = {
    validators: {
        [key: string]: Validator | undefined;
    };
};

export const RmaFormContext = React.createContext<ContextType>({
    validators: {},
});
const RequestRmaForm = ({ id, setCanSendReturnRequest }: Props) => {
    const [validators] = useState<{ [key: string]: Validator | undefined }>({});

    const handleFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const widgetValidators: Validator[] = [];
        Object.keys(validators).forEach(key => {
            const validator = validators[key];
            if (validator) {
                widgetValidators.push(validator);
            }
        });
        const results = widgetValidators.map(v => v());
        if (!results.every(o => o)) {
            setCanSendReturnRequest({ value: false });
        } else {
            setCanSendReturnRequest({ value: true });
        }
    };

    return (
        <GridContainer {...styles.container}>
            <GridItem {...styles.formGridItem}>
                <RmaFormContext.Provider value={{ validators }}>
                    <form onBlur={handleFormSubmit} onSubmit={handleFormSubmit} noValidate>
                        <Zone contentId={id} zoneName="Content01" />
                        <RequestRmaButtons handleValidate={handleFormSubmit} />
                    </form>
                </RmaFormContext.Provider>
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(null, mapDispatchToProps)(RequestRmaForm),
    definition: {
        group: "Return Request (RMA)",
        icon: "FormField",
    },
};

export default widgetModule;
